<template>
    <DrawerRoot v-model:open="isOpen" @close="closeDrawer">
        <DrawerPortal>
            <DrawerOverlay class="fixed inset-0 z-40 bg-black/20 backdrop-blur-sm" />
            <DrawerContent
                aria-describedby="undefined"
                class="bg-bg fixed inset-x-0 bottom-0 z-50 flex flex-col rounded-t-xl border-2 border-zinc-700"
                :class="autoHeight ? 'max-h-[80vh]' : 'h-[90vh]'"
            >
                <DrawerTitle class="sr-only">{{ $t('general.drawer') }}</DrawerTitle>
                <!-- <DrawerHandle class="mx-auto mt-2 mb-4 h-1 w-10 rounded-full bg-zinc-700" /> -->
                <div class="flex-1 overflow-y-auto p-5">
                    <slot v-if="isOpen" />
                </div>
                <div class="pb-safe"></div>
            </DrawerContent>
        </DrawerPortal>
    </DrawerRoot>
</template>

<script>
import {
    DrawerRoot,
    DrawerPortal,
    DrawerOverlay,
    DrawerContent,
    DrawerTitle,
} from 'vaul-vue'

export default {
    name: 'Drawer',
    components: {
        DrawerRoot,
        DrawerPortal,
        DrawerOverlay,
        DrawerContent,
        DrawerTitle,
    },
    props: {
        hashKey: {
            type: String,
            default: null,
        },
        autoHeight: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: false,
        }
    },
    watch: {
        $route: {
            handler(newRoute, oldRoute) {
                this.checkHash(newRoute, oldRoute)
            },
            immediate: false,
        },
        isOpen(newVal) {
            // Sync drawer state back to URL when closed via drag
            if (!newVal && this.$route.hash === `#${this.hashKey}`) {
                this.$router.replace({ hash: '' })
            }
        },
    },
    methods: {
        checkHash(newRoute, oldRoute) {
            if (newRoute.hash === `#${this.hashKey}`) {
                this.isOpen = true
            } else if (oldRoute?.hash === `#${this.hashKey}`) {
                this.isOpen = false
            }
        },
        closeDrawer() {
            if (this.$route.hash === `#${this.hashKey}`) {
                this.$router.replace({ hash: '' })
            }
        },
    },
    mounted() {
        this.checkHash(this.$route, null)
    },
}
</script>
